import React from 'react';
import './App.css'; // Assuming your CSS file

const Service3Second = () => {
    return (
        <div className="about-events-main-container"> {/* Main outer container */}
            <div className="about-events-container2">
                <div className="about-events-wrapper"> {/* Flexbox container */}
                    <div className="about-events-content2">
                        <h2 className="about-header-service2">Spend The Day Package Details</h2>
                        <p className="about-events-description2">
                            Celebrate your <strong>Spend the Day </strong> with us! Whether it's a <strong> family gathering, corporate retreat, friends' getaway, or a relaxing day off,</strong>  we’ve got you covered.<br/><br/>
                             </p>
                        <h2 className="about-subheader-service2">Choose Your Preferred Time Slot:</h2>
                                                <ul className="about-events-list2">
                                              <li>  🌞 Day Package – 9 AM to 5 PM</li>

                                              <li>  (Timings can be discussed based on your requirements.)</li>
                                              </ul>


                        <ul className="about-events-list2">
                        <h2 className="about-subheader-service2">Exclusive Package Includes:</h2>
                            <li>- Minimum Pax: <strong>25 persons (weekday) and 50 persons (weekend)</strong></li>
                            <li>- Maximum Pax: <strong>250 persons</strong></li>
                            <li>- Complimentary <strong>Welcome Drink</strong> for all guests</li>
                            <li>- Access to the <strong>Swimming Pool</strong> for a refreshing experience</li>
                            <li>- Delicious <strong>Lunch Buffet</strong> with a variety of dishes</li>
                            <li>- <strong>Evening Tea & Snack</strong> </li>
                            <li>- <strong>Compulsory Room</strong> for your comfort and privacy</li>
                            <li>- Groups of 50 persons, enjoy a <strong>free DJ </strong>to keep the energy high! </li>
                             <li>- And for groups of 100 or more, enjoy a <strong>free DJ and 2kg Chicken Bites </strong> </li>

                        </ul>
                    </div>

                    <div className="about-events-grid2">
                        <div className="about-events-images2">
                          <img
                            src={`${process.env.PUBLIC_URL}/package/pack-dayout.webp`}
                            className="service2-images3"
                            alt="Day Out Package"
                          />
                          <img
                            src={`${process.env.PUBLIC_URL}/package/nightpack.jpeg`}
                            className="service2-images3"
                            alt="Evening Package"
                          />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Service3Second;
